<template>
  <div class="header" style="padding:0;">
    <div class="product-label">
      <a @click="goHome">
        <img src="../../assets/images/logo_bw.png" class="logo">
        <span>小程序后台管理系统</span>
      </a>

    </div>
    <div class="toggle">
      <i :class="sidebar.opened ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="toggleCollapsed" />
    </div>

    <div style="display:flex;justify-content:flex-end;padding-right:20px;padding-left: 82px">
      <div class="login-info">
        <el-dropdown trigger="click">
          <div class="el-dropdown-link">
            <div style="display:flex;align-items:center;">
              <span class="admin-name" style="color:#fff; cursor: pointer;">{{ name }}</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { logout } from '@/api/user';
export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState('user', [
      'name', 'roles',
    ]),
    ...mapGetters([
      'sidebar',
    ]),
  },
  mounted() { },

  methods: {
    logout() {
      logout({}).then(async () => {
        await this.$store.dispatch('user/resetToken');
        this.$router.push({ path: '/login' }).catch(error => {
          console.log(error);
        });
      });
    },
    toggleCollapsed() {
      this.$store.dispatch('app/toggleSideBar');
    },
    goHome() {
      this.$router.push('/index');
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 66px;
  min-width: 900px;
  position: fixed;
  z-index: 3000;
  background: #1c1c1c;
  color: #fff;
  display: flex;
  width: 100%;
  padding: 0 15px;
  justify-content: space-between;
  align-items: center;
}

.product-label {
  width: 250px;
  background: #dc0019;
  height: 66px;
  cursor: pointer;

  a {
    width: 250px;
    height: 66px;
    display: block;
    line-height: 66px;
    text-align: center;
    font-size: 20px;
    font-weight: 700;

    .logo {
      width: 35px;
      vertical-align: middle;
      margin-right: 15px;
    }
  }
}
.toggle {
  flex: 1;
  padding-left: 28px;
  i {
    cursor: pointer;
  }
}
.el-dropdown-link {
  cursor: pointer;

  .admin-name {
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 200px;
    overflow: hidden;
  }

  .el-icon-arrow-down {
    color: #fff;
  }
}

.menu-collapsed {
  flex: 0 0 60px !important;
  width: 60px !important;
  overflow: inherit;
}

.menu-expanded {
  flex: 0 0 150px;
  width: 150px;
}
</style>
